import React from 'react';

interface BlockKitHelperProps {
  jsonContent: string;
}

const BlockKitHelper = ({
  jsonContent = ''
}: BlockKitHelperProps) => {
  const url = 'https://api.slack.com/tools/block-kit-builder#' + jsonContent;

  return (
    <div className="block-kit-helper">
      For advanced message styling and to preview your message&nbsp;
      <a href={url} target="_blank">go to Slack Block Kit Builder</a>.
    </div>
  )
};

export default BlockKitHelper;
